import React from "react";

import FacebookLink from "app/links/FacebookLink";
import InstagramLink from "app/links/InstagramLink";
import TiktokLink from "app/links/TiktokLink";

import FacebookBadge from "components/facebook/FacebookBadge";
import InstagramBadge from "components/instagram/InstagramBadge";
import EngageLinkedin from "components/linkedin/EngageLinkedin";
import LinkedinBadge from "components/linkedin/LinkedinBadge";
import TiktokBadge from "components/tiktok/TiktokBadge";

const SocialChannel = ({ justIcon, socialShare, socialType, useImageIcon }) => {
  switch (socialType) {
    case "linkedin":
    case "Linkedin":
      if (socialShare) {
        return (
          <EngageLinkedin story={socialShare?.entity} linkedinShare={socialShare}>
            <LinkedinBadge
              useImageIcon={useImageIcon}
              justIcon={justIcon}
              socialShare={socialShare}
            />
          </EngageLinkedin>
        );
      }
      return (
        <LinkedinBadge
          useImageIcon={useImageIcon}
          justIcon={justIcon}
          socialShare={socialShare}
        />
      );
    case "facebook":
    case "Facebook":
      if (socialShare) {
        return (
          <FacebookLink facebookId={socialShare.externalId}>
            <FacebookBadge
              useImageIcon={useImageIcon}
              justIcon={justIcon}
              socialShare={socialShare}
            />
          </FacebookLink>
        );
      }
      return (
        <FacebookBadge
          useImageIcon={useImageIcon}
          justIcon={justIcon}
          socialShare={socialShare}
        />
      );
    case "instagram":
    case "Instagram":
      if (socialShare) {
        return (
          <InstagramLink link={socialShare.url}>
            <InstagramBadge
              useImageIcon={useImageIcon}
              justIcon={justIcon}
              socialShare={socialShare}
            />
          </InstagramLink>
        );
      }
      return (
        <InstagramBadge
          useImageIcon={useImageIcon}
          justIcon={justIcon}
          socialShare={socialShare}
        />
      );
    case "tiktok":
    case "TikTok":
      if (socialShare) {
        return (
          <TiktokLink link={socialShare.url}>
            <TiktokBadge
              useImageIcon={useImageIcon}
              justIcon={justIcon}
              socialShare={socialShare}
            />
          </TiktokLink>
        );
      }
      return (
        <TiktokBadge
          useImageIcon={useImageIcon}
          justIcon={justIcon}
          socialShare={socialShare}
        />
      );
    default:
      break;
  }

  return <></>;
};

export default SocialChannel;
